import { fetchApi } from '../utils/fetchApi'

export const facmGet = ({ params }) => fetchApi({
  body: params,
  path: '/facm/get',
})

export const facmFilesGet = ({ params }) => fetchApi({
  body: params,
  path: '/facm/files/get',
})
